import { render } from "./Exchange.vue?vue&type=template&id=0be013a5&scoped=true&bindings={}"
import script from "./Exchange.vue?vue&type=script&lang=ts"
export * from "./Exchange.vue?vue&type=script&lang=ts"

import "./Exchange.vue?vue&type=style&index=0&id=0be013a5&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0be013a5"

export default script